import { defineStore } from 'pinia'
import type { IStep } from '@/interfaces/Interfaces'

export const useWizardStore = defineStore('wizardStore', () => {
  const triedToContinueStep = ref(false)
  const wizardSteps = ref<IStep[] | undefined>(undefined)
  const loadingWizard = ref<boolean>(false)

  const currentStep = (): IStep | undefined => {
    if (wizardSteps.value !== undefined) {
      return wizardSteps.value?.find((step: IStep) => step.active === true)
    }
    return undefined
  }

  const updateTriedToContinueStep = (val: boolean) => {
    triedToContinueStep.value = val
  }

  const setWizardSteps = async (steps: IStep[]) => {
    wizardSteps.value = steps
  }

  const setLoadingWizard = (toggle: boolean) => {
    loadingWizard.value = toggle
  }

  return {
    triedToContinueStep,
    wizardSteps,
    currentStep,
    updateTriedToContinueStep,
    setWizardSteps,
    loadingWizard,
    setLoadingWizard
  }
})
